import React from 'react'
import {
  container,
} from './layout-bootstrap.module.css'

import Container from 'react-bootstrap/Container';

import SiteNavbar from './site-navbar'


const Layout = ({ pageTitle, children }) => {
  
  return (
    <Container fluid className={container+ " px-0"}>
      <SiteNavbar></SiteNavbar>
      <main>
          {children}
        </main>
    </Container>

  )
}

export default Layout